import { FinancialConnection } from "@common/types/financialConnection";
import { useUser } from "@hooks/useUser";

export function useCanRemoveFinancialConnection(
    financialConnection: FinancialConnection,
) {
    const user = useUser();
    return financialConnection.userId === user.id;
}
